import { useBrand } from "../state/BrandContext";

export function BrandLoadingScreen(): React.ReactNode {
  const { brand } = useBrand();

  return (
    <div className="loading-screen" role="status" aria-live="polite">
      <span className="loading-mark" aria-label={brand.displayName}>
        {brand.displayName.slice(0, 1)}.
      </span>
      <p>Chargement de la marque…</p>
    </div>
  );
}
